module.exports = __webpack_public_path__ + "static/media/16UNODC9.a3979bb3.jpg";